class Menu {
    // 1. describe and create/initiate our object
    constructor() {
        this.hasChildrenLinks = document.querySelectorAll('.menu a.has-children');
        this.hasChildrenItems = document.querySelectorAll('.menu li.has-children');

        if (this.hasChildrenItems && this.hasChildrenLinks) {
            this.submenus = document.querySelectorAll('.submenu');
            if (this.submenus) {
                this.events();
            }
        }


    }

    // 2. events
    events() {
        this.hasChildrenItems.forEach(item => {
                item.addEventListener("mouseover", () => {
                    if (!item.classList.contains('.jsExpandMenu')) {                        
                        const parentItem = item.closest('li.has-children');
                        const submenu = parentItem.querySelector('.submenu');
                        parentItem.classList.add('jsExpandMenu');
                        submenu.classList.add('jsExpandMenu');
                    }
                })
                item.addEventListener("mouseout", () => {
                    if (item.classList.contains('jsExpandMenu')) {
                        const parentItem = item.closest('li.has-children');
                        const submenu = parentItem.querySelector('.submenu');
                        parentItem.classList.remove('jsExpandMenu');
                        submenu.classList.remove('jsExpandMenu');
                    }
                })
        });
        // this.submenus.forEach(submenu => {
        //         submenu.addEventListener("mouseover", () => {
        //             parentItem.classList.add('jsExpandMenu');
        //             submenu.classList.add('jsExpandMenu');
        //         })
        //         submenu.addEventListener("mouseout", () => {
        //             parentItem.classList.remove('jsExpandMenu');
        //             submenu.classList.remove('jsExpandMenu');
        //         })
        // });

    }

    // 3. methods (function, action...)

}

export default Menu;
